import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useAppSelector, useAppDispatch } from "store/index";
import { getSeoTypes } from "store/cms/pages/seo/slice";
import { handleUpdateFields, FaqItem } from "store/cms/pages/faq/slice";

import InnerInput from "components/inputs/InnerInput/InnerInput";
import SwitchBtn from "components/buttons/SwitchBtn";
import DefaultDropdown from "components/dropdowns/DefaultDropdown/DefaultDropdown";

interface PagesFaqMainTabProps {
  fieldErrors?: Record<string, string>;
  clearFieldError: (field: string) => void;
  readOnly?: boolean;
}

const PagesFaqMainTab: React.FC<PagesFaqMainTabProps> = ({
  fieldErrors,
  clearFieldError,
  readOnly,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const types = useAppSelector((store) => store.cmsSeo.types);
  const isTypesFetched = useAppSelector((store) => store.cmsSeo.isTypesFetched);
  const payload = useAppSelector((store) => store.cmsFaq.payload);

  const handleData = (key: string, value: string | boolean | number) => {
    dispatch(handleUpdateFields({ [key]: value } as Partial<FaqItem>));
  };

  useEffect(() => {
    if (!isTypesFetched) {
      dispatch(getSeoTypes());
    }
  }, [dispatch, isTypesFetched]);

  return (
    <div className="pages-form-content mt-14">
      <div className="row">
        <div className="pages-form-box--item">
          <InnerInput
            value={payload?.title ?? ""}
            placeholder={t("enterTitle")}
            label={t("title")}
            type="text"
            id="faq-title"
            onChange={(value) => {
              handleData("title", value);
              clearFieldError("title");
            }}
            hasError={Boolean(fieldErrors?.["title"])}
            disabled={readOnly}
          />
        </div>
        <div className="pages-form-box--item">
          <DefaultDropdown
            value={payload?.type ?? ""}
            placeholder={t("chooseType")}
            label={t("type")}
            options={types}
            onSelect={(val) => {
              handleData("type", String(val));
              clearFieldError("type");
            }}
            hasError={Boolean(fieldErrors?.["type"])}
            disabled={readOnly}
          />
        </div>
        <div className="pages-form-box--item">
          <SwitchBtn
            activeTxt={t("active")}
            isActive={!!payload?.isActive}
            handleClick={() =>
              handleData("isActive", !(payload?.isActive ?? false))
            }
            disabled={readOnly}
          />
        </div>
      </div>
    </div>
  );
};

export default PagesFaqMainTab;
